var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import Notification from "../../App/components/Notification";
import "../styles/UploadingArtFiles.css";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import LinkIcon from '@mui/icons-material/Link';
import SubmissionsForProviderApprovalService from "../services/SubmissionsForProviderApprovalService";
import { handleServiceError } from "../../App/components/ErrorHandler";
function UploadingArtFiles(props) {
    var _a = useState(), fileArchive = _a[0], setFileArchive = _a[1];
    var _b = useState(), fileData = _b[0], setFileData = _b[1];
    var _c = useState(""), linkText = _c[0], setLinkText = _c[1];
    var _d = useState([]), rejectedFiles = _d[0], setRejectedFiles = _d[1];
    var _e = useState(""), emptyFiles = _e[0], setEmptyFiles = _e[1];
    var _f = useState(), subject = _f[0], setSubject = _f[1];
    useEffect(function () {
        if (fileArchive || linkText.trim()) {
            setEmptyFiles('');
        }
    }, [fileArchive, linkText]);
    var onDropAccepted = useCallback(function (acceptedFiles) {
        setRejectedFiles([]);
        acceptedFiles.forEach(function (file) {
            handleFile(file);
        });
    }, []);
    var onDropRejected = useCallback(function (fileRejections) {
        var message = "";
        fileRejections.map(function (item) {
            switch (item.errors[0].code) {
                case "file-invalid-type":
                    message = "O formato do arquivo deve ser SVG, PNG, JPG, PDF, MP3, MP4, ZIP (max. 5MB)";
                    break;
                case "too-many-files":
                    message = "Arraste um arquivo por vez!";
                    break;
                default:
                    message = item.errors[0].message;
                    break;
            }
            Notification().Notify.failure("Erro ao fazer o upload do arquivo " +
                item.file.name, {
                timeout: 7000,
                width: '300px'
            });
        });
        setRejectedFiles(fileRejections);
        return message;
    }, []);
    function handleFile(file) {
        var _a;
        var reader = new FileReader();
        var newFile = {
            name: file.name,
            size: file.size,
            progress: 0,
        };
        setFileArchive(file);
        (_a = props === null || props === void 0 ? void 0 : props.setFile) === null || _a === void 0 ? void 0 : _a.call(props, file);
        reader.readAsDataURL(file);
        setFileData(newFile);
    }
    ;
    var _g = useDropzone({
        onDropAccepted: onDropAccepted,
        onDropRejected: onDropRejected,
        onDrop: function (acceptedFiles) {
            var _a;
            var file = acceptedFiles[0];
            (_a = props.handleFileEmail) === null || _a === void 0 ? void 0 : _a.call(props, file);
        },
        accept: ["image/*", "audio/*", "video/*", ".zip", ".pdf",],
        maxSize: 5242880,
        maxFiles: 1,
        multiple: false,
    }), getRootProps = _g.getRootProps, getInputProps = _g.getInputProps, isDragActive = _g.isDragActive;
    function sendFile(fileArchive) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, textToBackend;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        if (fileArchive) {
                            if (Array.isArray(fileArchive)) {
                                textToBackend = fileArchive.join("\n");
                                formData.append("textToBackend", textToBackend);
                            }
                            else if (fileArchive instanceof File) {
                                formData.append("file", fileArchive);
                            }
                        }
                        ;
                        if (subject !== undefined) {
                            formData.append("subject_of_art", subject);
                        }
                        Notification().Loading.dots("Importando");
                        return [4 /*yield*/, SubmissionsForProviderApprovalService.storeManyArts(formData)
                                .then(function (res) {
                                Notification().Loading.remove();
                                Notification().Notify.success("Importação finalizada. Confira a lista abaixo.");
                                props.closeModal && props.closeModal();
                                setRejectedFiles([]);
                                window.location.reload();
                            })
                                .catch(function (err) {
                                Notification().Loading.remove();
                                handleServiceError(err);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function () {
            var fileEmpty, linkEmpty, links;
            return __generator(this, function (_a) {
                event.preventDefault();
                fileEmpty = !fileArchive || (Array.isArray(fileArchive) && fileArchive.length === 1 && fileArchive[0].trim() === '');
                linkEmpty = !linkText || linkText.trim() === '';
                if (fileEmpty && linkEmpty) {
                    setEmptyFiles('Por favor, insira um link ou envie um arquivo.');
                    return [2 /*return*/];
                }
                event.preventDefault();
                links = linkText.split("\n");
                if (fileArchive) {
                    sendFile(fileArchive);
                }
                else if (links.length > 0) {
                    sendFile(links);
                }
                return [2 /*return*/];
            });
        });
    }
    ;
    function containerUploadingArtFiles() {
        return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "container-uploading-art-files" }, getRootProps(), { style: { opacity: linkText ? ".4" : "1", pointerEvents: linkText ? "none" : "initial" } }, { children: [_jsx("input", __assign({ id: "input-file", type: "file" }, getInputProps())), isDragActive ? (_jsx("div", __assign({ className: "warning-to-drop-files" }, { children: _jsx("p", { children: "Solte os arquivos aqui e aguarde o upload e processamento dos dados." }) }))) : (_jsxs("div", __assign({ className: "uploading-arts" }, { children: [_jsx(UploadFileIcon, {}), _jsxs("p", { children: [_jsx("strong", { children: "Clique para fazer o upload " }), " ou arraste aqui"] }), _jsx("span", { children: "Formatos suportados: SVG, PNG, JPG, PDF, MP3, MP4, ZIP (max. 5MB)" })] }))), (fileData === null || fileData === void 0 ? void 0 : fileData.name) &&
                        _jsx("div", __assign({ className: "uploading-art-file-name" }, { children: _jsx("p", { children: fileData.name }) })), rejectedFiles.length > 0 &&
                        _jsx("div", __assign({ className: "rejected-files" }, { children: _jsx("span", { children: "A importa\u00E7\u00E3o do arquivo falhou devido ao tamanho exceder 5 MB." }) }))] })) }));
    }
    ;
    function containerActionsButtonUploadArtFiles() {
        return (_jsxs(_Fragment, { children: [_jsx("div", { children: emptyFiles && (_jsxs("p", __assign({ style: { color: '#FF0000', marginTop: '10px', marginLeft: '3px' } }, { children: [emptyFiles, " "] }))) }), _jsxs("div", __assign({ className: "container-actions-button-upload-art-files" }, { children: [_jsx("button", __assign({ id: "btn-upload-art-cancel", className: "button-with-blue-border cancel-sending-the-file-button", onClick: function (e) { e.preventDefault(); props.closeModal && props.closeModal(); } }, { children: "Cancelar" })), rejectedFiles.length > 0 && fileArchive === undefined ? (_jsx("button", __assign({ id: "btn-upload-art-send", className: "blue-button confirm-file-sending-button", style: { pointerEvents: "none", backgroundColor: "rgba(45, 45, 45, 0.18)", color: "#646464", border: "none" } }, { children: "Enviar" }))) : (_jsx("button", __assign({ id: "btn-upload-art-send", className: "blue-button confirm-file-sending-button", type: "submit" }, { children: "Enviar" })))] }))] }));
    }
    return (_jsxs(_Fragment, { children: [props.pageName === "upload_arts" &&
                _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", { children: [_jsx("h4", { children: "Assunto" }), _jsx("input", { type: "text", className: "subject-of-submission-input", value: subject, onChange: function (e) { return setSubject(e.target.value); }, required: true }), _jsx("h4", { children: "Envios" }), _jsxs("div", __assign({ className: "input-with-icon", style: { opacity: fileArchive ? ".3" : "1", pointerEvents: fileArchive ? "none" : "initial" } }, { children: [_jsx("input", { type: "url", className: "url-submission-input", placeholder: "Cole o link aqui", value: linkText, onChange: function (e) { setLinkText(e.target.value); } }), _jsx(LinkIcon, { className: "placeholder-icon" })] }))] }), containerUploadingArtFiles(), containerActionsButtonUploadArtFiles()] })), props.pageName === "ticket_history/".concat(props.artId) &&
                _jsxs("form", __assign({ onSubmit: props.handleFormSubmit }, { children: [_jsxs("div", __assign({ className: "container-ticket-intent" }, { children: [_jsx("h4", { children: "Inten\u00E7\u00E3o" }), _jsxs("div", { children: [_jsxs("div", { children: [_jsx("input", { type: "radio", id: "correction-radio", checked: props.isCorrection, onChange: props.handleCorrectionClick }), _jsx("label", __assign({ htmlFor: "correction-radio" }, { children: "Enviar corre\u00E7\u00E3o" }))] }), _jsxs("div", __assign({ className: "contest" }, { children: [_jsx("input", { type: "radio", id: "contest-radio", checked: props.isContesting, onChange: props.handleContestClick }), _jsx("label", __assign({ htmlFor: "contest-radio" }, { children: "Contestar" }))] }))] })] })), _jsxs("div", __assign({ className: "container-justification" }, { children: [_jsx("h4", { children: "Justificativa" }), _jsx("textarea", { id: "exampleFormControlTextarea1", value: props.textAreaValue, onChange: props.handleChange })] })), !props.isContesting &&
                            _jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("h4", { children: "Envios" }), _jsxs("div", __assign({ className: "input-with-icon", style: { opacity: fileArchive ? ".3" : "1", pointerEvents: fileArchive ? "none" : "initial" } }, { children: [_jsx("input", { type: "url", className: "url-submission-input", placeholder: "Cole o link aqui", value: props.linkText || "", onChange: function (e) { return props.setLinkText && props.setLinkText(e.target.value); } }), _jsx(LinkIcon, { className: "placeholder-icon" })] }))] }), containerUploadingArtFiles()] }), containerActionsButtonUploadArtFiles()] })), props.pageName === "aproval_arts" &&
                _jsxs("div", __assign({ className: "container-uploading-art-files container-uploading-art-files-approval-arts" }, getRootProps(), { style: { opacity: linkText ? ".4" : "1", pointerEvents: linkText ? "none" : "initial" } }, { children: [_jsx("input", __assign({ id: "input-file", type: "file" }, getInputProps())), isDragActive ? (_jsx("div", __assign({ className: "warning-to-drop-files warning-to-drop-files-approval" }, { children: _jsx("p", { children: "Solte os arquivos aqui e aguarde o upload e processamento dos dados." }) }))) : (_jsxs("div", __assign({ className: "uploading-arts uploading-arts-approval" }, { children: [_jsx(UploadFileIcon, {}), _jsxs("p", { children: [_jsx("strong", { children: "Clique para fazer o upload " }), " ou arraste aqui"] })] }))), rejectedFiles.length > 0 &&
                            _jsx("div", __assign({ className: "rejected-files" }, { children: _jsx("span", { children: "A importa\u00E7\u00E3o do arquivo falhou devido ao tamanho exceder 5 MB." }) })), (fileData === null || fileData === void 0 ? void 0 : fileData.name) &&
                            _jsx("div", __assign({ className: "uploading-art-file-name uploading-art-file-name-approval" }, { children: _jsx("p", { children: fileData.name }) }))] }))] }));
}
export default UploadingArtFiles;
